import React from 'react';
function TitleTooltip(props) {
    return React.createElement("pre", { style: { fontSize: '12px', fontFamily: 'Inter' } }, props.msg);
}
export default TitleTooltip;
